import { CircleCheckBig } from 'lucide-react';
import styles from './SenhaRecuperada.module.scss';
import { Link } from 'react-router-dom';

export const SenhaRecuperada = () => {




  return (
    <div className={styles.page}>
      <div className={styles.containerLogado}>
        < CircleCheckBig className={styles.iconSucesso}  />
        <h2 className={styles.title}>Senha criada com Sucesso!</h2>
        <Link to="/login" className={styles.button}>Voltar para Login</Link>
      </div>
    </div>
  );
};
